import { Box, Button, Grid, Tab, Tabs, Typography } from "@mui/material";
import React, { useState } from "react";
import "./userpage.scss";
import "../assets/styles/common-styles.scss";
import AddIcon from "@mui/icons-material/Add";
import { useAppDispatch } from "../store";
import buttonConfig from "../config/buttonConfig.json";
import {
  setOpenRolesModal,
  setOpenUserModal,
} from "../store/slices/usersSlice";
import UserList from "../components/users/UserList";
import RolesList from "../components/users/RolesList";
import PermissionsList from "../components/users/PermissionsList";
import PermissionCheck from "../components/common/PermissionCheck/PermissionCheck";
import { usePermissionWrapper } from "../hooks/usePermissionWrapper";
import LoginHistory from "../components/users/LoginHistory";

interface ButtonConfig {
  label: string;
  onClick: string;
}

type ButtonConfigMap = {
  [key: string]: ButtonConfig;
};

const buttonConfigMap: ButtonConfigMap = buttonConfig as ButtonConfigMap;

const UsersPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const { checkPermission } = usePermissionWrapper();

  const onClickAddUser = () => {
    dispatch(setOpenUserModal(true));
  };

  const [value, setValue] = useState(0);
  const [activeTab, setActiveTab] = useState("users-tab");

  const handleChange = (event: any, newValue: number) => {
    setValue(newValue);
    setActiveTab(event.target.id);
  };
  const onClickAddRoles = () => {
    dispatch(setOpenRolesModal(true));
  };

  const getButtonConfig = () => {
    const config =
      buttonConfigMap[activeTab] || buttonConfigMap["permissions_tab"];
    switch (config.onClick) {
      case "onClickAddUser":
        return { label: config.label, onClick: onClickAddUser };
      case "onClickAddRoles":
        return { label: config.label, onClick: onClickAddRoles };
      default:
        return {
          label: config.label,
          onClick: () => {
            console.debug("btn");
          },
        };
    }
  };
  const { label, onClick } = getButtonConfig();

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs>
          <Typography variant="h4" gutterBottom>
            Users
          </Typography>
        </Grid>
        {label && (
          <Grid item justifyContent="flex-end">
            <Box display="flex" justifyContent="flex-end" columnGap={2}>
              <PermissionCheck
                permission={
                  activeTab == "users-tab"
                    ? "CREATE_USER"
                    : activeTab == "roles-tab"
                    ? "CREATE_ROLE"
                    : "true"
                }
              >
                <Button
                  variant="contained"
                  endIcon={<AddIcon />}
                  onClick={onClick}
                  id={`${activeTab}-${label}`}
                  aria-label={`Click to ${label}`}
                >
                  {label}
                </Button>
              </PermissionCheck>
            </Box>
          </Grid>
        )}
      </Grid>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="User Management Tabs"
        className="expandedTabs"
        selectionFollowsFocus
      >
        {checkPermission("VIEW_ALL_USERS") && (
          <Tab label="Users" id="users-tab" />
        )}
        {checkPermission("VIEW_ALL_ROLES") && (
          <Tab label="Roles" id="roles-tab" />
        )}
        {checkPermission("VIEW_ALL_PERMISSIONS") && (
          <Tab label="Permissions" id="permissions-tab" />
        )}
        {checkPermission("VIEW_LOGIN_HISTORY") && (
          <Tab label="Login History" id="loginHistory-tab" />
        )}
      </Tabs>
      <Box sx={{ pt: 3 }}>
        {activeTab == "users-tab" ? (
          <UserList />
        ) : activeTab == "roles-tab" ? (
          <RolesList />
        ) : activeTab == "permissions-tab" ? (
          <PermissionsList />
        ) : (
          <LoginHistory />
        )}
      </Box>
    </>
  );
};

export default UsersPage;
